// author: lx
// latest: zhangmyh 2017-4-1 2:05 PM
/* global $ u ko */
import { Get } from 'common'
import EventBus from 'common/eventbus'
import uMessage from 'components/message'

let enterprise = {
  enterpriseName: '租户名称',
  enterpriseId: window.global.user.enterpriseId
}
function init (refer, obj) {
  var _refer = refer
  let vm, data
  if (refer.options.data) {
    data = refer.options.data
    let isshow = true
    if (data.children.value) {
      isshow = false
    }
    vm = {
      data: ko.observableArray([
        {
          id: data.id.value,
          name: data.title.value,
          parentId: '',
          remark: '',
          enterpriseId: enterprise.enterpriseId,
          enterpriseName: enterprise.enterpriseName,
          comItems: ''
        }
      ]),
      show: isshow,
      selectshow: false,
      nodedelete: function () {
        window.u.confirmDialog({
          id: 'confirmDialog',
          msg: '您确定要删除所选数据吗？',
          title: '确认删除',
          onOk: function () {
            _refer.cancel()
            const setOrder = async function () {
              let result = await Get('/cpu-supplymgr/rejectCommon/deleteRejectCommonType?id=' + data.id.value)
              if (result.status === 1) {
                uMessage('success', result.msg)
                $('#addBtn_' + data.pid.value).unbind().remove()
                EventBus.emit('allreload')
              } else {
                uMessage('fail', result.msg)
              }
            }
            setOrder()
          },
          onCancel: function () {}
        })
      },
      comItems: [{
        'value': '1',
        'name': '当前节点'
      }, {
        'value': '0',
        'name': '根节点'
      }]
    }
  } else {
    vm = {
      data: ko.observableArray([
        {
          name: '',
          parentId: '',
          remark: '',
          enterpriseId: enterprise.enterpriseId,
          enterpriseName: enterprise.enterpriseName,
          comItems: ''
        }
      ]),
      show: false,
      selectshow: true,
      nodedelete: function () {
      },
      comItems: [{
        'value': '1',
        'name': '当前节点'
      }, {
        'value': '0',
        'name': '根节点'
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#new_aptitude_sorting')[0])
  refer.registerSubmitFunc(() => {
    return vm.data()
  })
}
let template = require('./index.html')
export default {
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/rejectSorting/index.js